module.exports = ".r-items:hover {\n  cursor: pointer;\n  color: #2196f3; }\n\nmat-list-item {\n  max-width: 350px; }\n"